// @ts-strict-ignore
import { Component, EventEmitter, Output } from '@angular/core';
import { ProjectUtils } from '@project/components/project/util/project-utils';
import { ProjectModel } from '@project/model/project.model';
import { SavedProjectData, SaveProjectService } from '../project-save/save-project.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  templateUrl: './project-save-popup.component.html',
  selector: 'app-modal-save-project-popup',
})
export class ModalSaveProjectPopupComponent {

  @Output() public finish = new EventEmitter<boolean>();

  constructor(private projectModel: ProjectModel, private saveProjectService: SaveProjectService) {
    this.saveProjectService.savedProject$
      .pipe(takeUntilDestroyed())
      .subscribe(data => this.savedProject(data));
  }

  public async save(saveNewVersion: boolean): Promise<void> {
    if (saveNewVersion || ProjectUtils.isEmptyProject(this.projectModel.currentProject) || this.projectModel.isNewConfiguration) {
      await this.saveProjectService.prepareSaveProject();
    } else {
      await this.saveProjectService.prepareSaveProject(SaveProjectService.PREPARE_PROJECT_SAVE);
    }
  }

  public close(): void {
    this.finish.emit(false);
  }

  private savedProject(data: SavedProjectData) {
    if (data.success) {
      this.finish.emit(true);
    }
  }
}
